var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('strong',[_vm._v("Copyright © 2014-"+_vm._s(_vm.year)+" "),_c('a',{attrs:{"tabindex":"-1","href":"#"}},[_vm._v("TRUE WORK")]),_vm._v(".")]),_vm._v(" Todos direitos reservados. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }